import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
@withTranslation()
@inject('appStore')
@observer
class PopUpMessageModal extends Component {
  closeDialog = () => {
    this.props.appStore.setPopMessage(null, null);
  };

  componentDidMount() {
    if (this.props.appStore.popupMessage) this.showModal();
  }

  showModal = () => {
    const $ = window.$;
    $('#modal-popup-message').modal({
      backdrop: 'static',
      keyboard: false,
      show: true,
    });
  };

  hideModal = () => {
    const $ = window.$;
    $('#modal-popup-message').modal('hide');
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.appStore.popupMessage) {
      this.showModal();
    } else {
      this.hideModal();
    }
  }

  render() {
    const { t, appStore } = this.props;
    const { popupShowOkButton } = appStore;
    return (
      <div
        className="modal modal-popup-message in"
        id="modal-popup-message"
        tabIndex="-1"
        role="dialog"
      >
        <div
          className={`modal-dialog ${
            this.props.appStore.popupSize
              ? this.props.appStore.popupSize + ''
              : ''
          }`}
          role="document"
        >
          <div className="modal-content">
            <button className="close" onClick={this.closeDialog}>
              <i className="icon-close"></i>
            </button>

            <div className="modal-header justify-content-center ">
              <span>
                <svg
                  width="60"
                  height="66"
                  viewBox="0 0 20 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 11.8C10.4 11.8 10.8 11.5 10.8 11V6.5C10.8 6.1 10.5 5.7 10 5.7C9.5 5.7 9.2 6 9.2 6.5V11C9.2 11.4 9.6 11.8 10 11.8Z"
                    fill="red"
                    fillOpacity="0.7"
                  />
                  <path
                    d="M17.1 4.1L12.6 1.5C11 0.5 9 0.5 7.4 1.5L2.9 4.1C1.2 5 0.200001 6.8 0.200001 8.6V13.4C0.200001 15.3 1.2 17 2.8 17.9L7.3 20.5C8.1 21 9 21.2 9.9 21.2C10.8 21.2 11.7 21 12.5 20.5L17 17.9C18.6 17 19.6 15.2 19.6 13.4V8.6C19.8 6.8 18.8 5 17.1 4.1ZM18.2 13.4C18.2 14.7 17.5 16 16.3 16.6L11.8 19.2C10.6 19.9 9.2 19.9 8 19.2L3.5 16.6C2.4 15.9 1.6 14.7 1.6 13.4V8.6C1.6 7.3 2.3 6 3.5 5.4L8 2.8C8.6 2.5 9.2 2.3 9.9 2.3C10.6 2.3 11.2 2.5 11.8 2.8L16.3 5.4C17.4 6.1 18.2 7.3 18.2 8.6V13.4Z"
                    fill="red"
                    fillOpacity="0.7"
                  />
                  <path
                    d="M11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14Z"
                    fill="red"
                    fillOpacity="0.7"
                  />
                </svg>
              </span>
            </div>
            <div className="modal-body">
              <p
                className="fs-14 text-center"
                dangerouslySetInnerHTML={{
                  __html: this.props.appStore.popupMessage,
                }}
              ></p>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={this.closeDialog}
                id="close-button"
                type="button"
              >
                {t('Okay, Got it!')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PopUpMessageModal;
